// The troops of the last attack sent from each city (Ben, Oct 15 2026), so Rally Point › Commands opens with the same
// numbers again. Only troop types the player sent part of are remembered — a type sent with every one at home is not
// carried. Coming back, each type is set to the same number, or to all at home when there are fewer than that.
// Kept per world and city on this device, and across reopening the app.
import { create } from "zustand";
import type { TroopKey } from "@/game/constants";

const KEY = "valor-web:rally-last-attack";
type Units = Partial<Record<TroopKey, number>>;

function load(): Record<string, Units> {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") as Record<string, Units>;
  } catch {
    return {};
  }
}

export const lastAttackKey = (wid: number | string, vid: number | string) => `${wid}:${vid}`;

interface RallyLastAttackState {
  byCity: Record<string, Units>;
  set: (wid: number | string, vid: number | string, units: Units) => void;
}

export const useRallyLastAttack = create<RallyLastAttackState>((set, get) => ({
  byCity: load(),
  set: (wid, vid, units) => {
    const next = { ...get().byCity };
    const k = lastAttackKey(wid, vid);
    if (Object.keys(units).length) next[k] = units;
    else delete next[k];
    set({ byCity: next });
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
      /* private mode: remembered for this visit */
    }
  },
}));
